import * as React from 'react';
import CollapseButton from '../CollapseButton/CollapseButton';
/* eslint-disable no-unused-vars */
import ChromeProps from './ChromeProps.interface';
import './chrome.scss';

const Chrome = ({
  Header,
  Nav,
  Content,
  leftNavIsCollapsed,
}: ChromeProps): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = React.useState(!!leftNavIsCollapsed);

  const collapsed = isCollapsed
    ? 'is-collapsed'
    : '';

  const toggleCollapse = (): void => { setIsCollapsed(!isCollapsed); };

  return (
    <div className="site-container">
      <header className="site-header">
        <Header />
      </header>
      <div className="site-content">
        <section className={`site-nav__container ${collapsed}`.trim()}>
          <Nav />
          <nav className="legal__nav">
            <ul className="u-list-inline">
              <li className="legal__item">©2021 Vertex, Inc. All rights reserved.</li>
            </ul>
          </nav>
          <CollapseButton onClick={toggleCollapse} />
        </section>
        <main className="content__container">
          <Content />
        </main>
      </div>
    </div>
  );
};

export default Chrome;
